<div id="wrapper">
        <app-loading-screen></app-loading-screen>  
    <div class="allcont">
      <app-menu [tabActive]="this.tabActive"></app-menu>
      <app-loading-screen></app-loading-screen>
        <div class="basicrow mbott">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle">
                    <img width="100%" class="userimgicon" src="../../assets/images/usersvicon.png"> Usuarios y Permisos
                </div>
                <div class="basicrow m-top-i mbott-i text-center m-bot-m" *ngIf="this.typeOfAction=='add'">
                    <div class="stepsvone">
                        <div class="stepautoc on first" [className]="this.sessionView===1 ? 'stepautoc on first' : 'stepautoc first'">
                            Creaci&oacute;n de Usuario
                            <div class="stepcirc text-center">
                                <div class="circ-in"></div>
                            </div>
                        </div>
                        <div class="stepautoc middle" [className]="this.sessionView===2 ? 'stepautoc on middle' : 'stepautoc middle'">
                            Asignaci&oacute;n de Permisos
                            <div class="stepcirc">
                                <div class="circ-in"></div>
                            </div>
                        </div>
                        <div class="stepautoc last" [className]="this.sessionView===3 ? 'stepautoc on last' : 'stepautoc last'">
                            Resumen y Confirmaci&oacute;n
                            <div class="stepcirc">
                                <div class="circ-in"></div>
                            </div>
                        </div>
                        <div class="stepsline"></div>
                    </div>
                </div>
                <div *ngIf="this.sessionView==1">
                    <app-create-user (nextStep)="this.sessionView=$event" (updateName)="this.name=$event" (updateLastName)="this.lastName=$event"(updateEmail)="this.email=$event"(updateNum)="this.phoneNumber=$event" (updateIdRole)="this.idRole=$event" (updateRole)="this.role=$event" (updateAccount)="this.acount=$event"></app-create-user>
                </div>
                <div *ngIf="this.sessionView==2">
                    <app-permission-assignment [tunnel]="this.tunnel" (nextStep)="this.sessionView=$event" [name]="this.name" [(email)]="this.email" [(phoneNumber)]="this.phoneNumber" [(lastName)]="this.lastName" [(idRole)]="this.idRole" [(role)]="this.role" [(acount)]="this.acount" [(token)]="this.token"></app-permission-assignment>
                </div>
                <div *ngIf="this.sessionView==3">
                    <app-summary-confirmation  [name]="this.name" [(email)]="this.email" [(phoneNumber)]="this.phoneNumber" [(lastName)]="this.lastName" [(role)]="this.role"></app-summary-confirmation>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
  </div>
  